<template>
  <div class="footer">
    <field-popup />
    <div class="footer__core">
      <div class="footer__help-buttons">
        <app-button :text="$t('footer.isThisLegal')" :action="isThisLegal"></app-button>
        <app-button :text="$t('footer.iHaveAQuestion')" :action="question" v-if="$store.getters.canShowQuestions"></app-button>
      </div>
      <div class="footer__core__right">
        <app-button data-cy="next" :text="$store.getters.footerNextButtonText()" :action="nextField" classList="button--cta float-right"></app-button>
        <div class="footer__info float-right">{{ itemsToCompleteText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton'
import FieldPopup from '@/components/FieldPopup'
import nextActionUtil from '@/utils/next-action'
import { mapGetters } from 'vuex'

export default {
  name: 'document-footer',
  components: {
    AppButton,
    FieldPopup
  },
  computed: {
    ...mapGetters(['outstandingFieldsNo']),
    itemsToCompleteText () {
      if (this.outstandingFieldsNo === 0) {
        return this.$t('footer.allComplete')
      } else if (this.outstandingFieldsNo === 1) {
        return this.$t('footer.oneToComplete')
      }

      return this.$t('footer.pluralToComplete', { count: this.outstandingFieldsNo })
    }
  },
  methods: {
    isThisLegal () {
      this.$bus.$emit('openModal', 'helpModal')
      this.$bus.$emit('selectTab', 'is-this-legal')
    },
    question () {
      this.$bus.$emit('openModal', 'helpModal')
      this.$bus.$emit('selectTab', 'contact-signable-team')
    },
    nextField () {
      nextActionUtil()
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .footer
    background-color: #fff
    position: fixed
    bottom: 0
    right: 0
    width: 75%
    box-shadow: 0px -15px 15px -20px $color-grey
    @include clearfix
    a
      margin-left: $spacing-base
      &:first-child
        margin-left: 0
      &.float-right
        margin-left: 0
    &__core
      padding: $spacing-base
      min-height: 75px
      &__right
        a.button
          margin-left: $spacing-base
    &__info
      padding: $spacing-small + 2
      padding-right: 0
      color: $color-main-dark
      font-weight: bold
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .footer
      width: 100%
      &__help-buttons
        display: none
</style>
